import { render } from "./notes.vue?vue&type=template&id=74848fba&scoped=true"
const script = {}

import "./notes.vue?vue&type=style&index=0&id=74848fba&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74848fba"]])

export default __exports__